const locale = {
  cancel: '取消',
  confirm: '确认',
  reset: '重置'
};
export default locale;